// 3507DeleteYB.js - 医保信息删除接口
import {ybRequestTemplate} from "/src/untils/ybRequestTemplate.js"
import {addYbRquestData, getqdNo} from "@/api/yb";
import axios from "axios";
import dayjs from "dayjs";

/**
 * 医保信息删除接口 (3507)
 * @param {Object} row - 要删除的行数据
 * @param {Object} userData - 用户信息
 * @param {Object} clinicInfo - 诊所信息
 * @param {Function} addStepMessage - 添加步骤消息的函数
 * @param {Function} addOperationStepMessage - 添加操作步骤消息的函数
 * @param {Function} updateOperationProgress - 更新进度条的函数
 * @param {Function} updateOperationStepStatus - 更新步骤状态的函数
 * @returns {Promise} 删除结果
 */
export const deleteMedicalInsurance = async (
  row, 
  userData, 
  clinicInfo, 
  addStepMessage, 
  addOperationStepMessage, 
  updateOperationProgress,
  updateOperationStepStatus
) => {
  try {
    addStepMessage('开始执行医保信息删除流程(3507)...');
    
    // 准备删除请求数据
    addOperationStepMessage('准备删除请求数据...');
    const ybRequest = JSON.parse(JSON.stringify(ybRequestTemplate));
    const today = dayjs().format('YYYY-MM-DD');
    
    // 获取签到编号
    const signNoRes = await getqdNo();
    let signNo = '';
    if (signNoRes.code === 200) {
      signNo = signNoRes.data.signNo;
      addStepMessage(`签到业务ID: ${signNo}`);
    } else {
      throw new Error('获取签到流水号失败');
    }
    
    // 生成机器ID（截取前20位）
    const machineId = (row.machineId || 'default_machine_id').slice(0, 20);
    
    // 设置请求参数 - 3507接口
    ybRequest.body.infno = '3507';
    ybRequest.body.msgid = `${userData.clinicCode || '000000'}${dayjs().format('YYYYMMDDHHmmss')}${getRandom4Digits()}`;
    ybRequest.body.insuplc_admdvs = userData.mdtrtareaAdmvs || '';
    ybRequest.body.mdtrtarea_admvs = userData.mdtrtareaAdmvs || '';
    ybRequest.body.recer_admdvs = userData.mdtrtareaAdmvs || '';
    ybRequest.body.recer_sys_code = '007';
    ybRequest.body.infver = 'V1.049';
    ybRequest.body.opter_type = '1';
    ybRequest.body.opter = userData.userId || '1';
    ybRequest.body.opter_name = userData.staffName || '系统操作员';
    ybRequest.body.inf_time = dayjs().format('YYYY-MM-DD HH:mm:ss');
    ybRequest.body.fixmedins_code = userData.clinicCode || '';
    ybRequest.body.fixmedins_name = userData.clinicName || '';
    ybRequest.body.sign_no = signNo;
    
    // 设置删除数据 - 根据3507接口规范
    ybRequest.body.input.data = {
      fixmedins_bchno:'', // 定点医药机构批次流水号
	  inv_data_type:'', // 1-盘存信息；2- 库存变更信息；3-采购信息；4- 销售信息
    };
    
    addStepMessage('准备调用接口传输删除数据(3507)...');
    
    // 先传给系统
    const newItem = {
      infno: 3507,
      mdtrtareaAdmvs: userData.mdtrtareaAdmvs || '',
      data: JSON.stringify(ybRequest.body),
      patientId: userData.staffId || '',
      patientName: userData.staffName || '系统操作员'
    };
    
    const res = await addYbRquestData(newItem);
    
    if (res.code !== 200) {
      throw new Error('医保删除数据准备失败: ' + res.message);
    }
    
    addStepMessage('医保删除数据准备完成，开始上传接口(3507)...');
    
    let responseData = res.data;
    if (typeof responseData === 'string') {
      try {
        responseData = JSON.parse(responseData);
      } catch (parseError) {
        throw new Error('解析医保响应数据失败');
      }
    }
    
    // 设置请求头
    ybRequest.headers.infosyscode = responseData.infosyscode || '';
    ybRequest.headers.hsf_signature = responseData.signature || '';
    ybRequest.headers.fixmedins_code = userData.clinicCode || '';
    ybRequest.headers.hsf_nonce = responseData.hsfNonce || '';
    ybRequest.headers.hsf_timestamp = responseData.hsfTimestamp || '';
    
    addStepMessage('调用医保信息删除接口(3507)...');
    updateOperationProgress(70);
    updateOperationStepStatus(1, 'loading');
    
    // 调用医保接口
    const axiosConfig = {
      method: 'post',
      url: process.env.VUE_APP_BASE_YBHOST + `/eapdomain/callService`,
      baseURL: '',
      headers: ybRequest.headers,
      data: ybRequest.body,
    };
    
    const response = await axios(axiosConfig);
    const result = response.data || response;
    
    // 处理响应结果
    if (result.infcode === 0) {
      addStepMessage('医保信息删除成功(3507)', { level: 'success' });
      updateOperationProgress(100);
      updateOperationStepStatus(1, 'success');
      return result;
    } else {
      let errorMsg = '医保信息删除失败(3507)';
      if (result) {
        errorMsg = result.err_msg || result.msg || result.message || '未知错误';
      }
      throw new Error(errorMsg);
    }
    
  } catch (error) {
    console.error('调用医保信息删除接口(3507)异常:', error);
    updateOperationProgress(100);
    updateOperationStepStatus(1, 'error');
    throw error;
  }
};

/**
 * 生成4位随机数
 * @returns {string} 4位随机数字
 */
const getRandom4Digits = () => {
  return Math.floor(1000 + Math.random() * 9000).toString();
};

export default {
  deleteMedicalInsurance
};